<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dictee | Digitaal" [steps]="words().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    @for (input of [instruction()]; track input) {
      <rid-mechanic-title [title]="input" animate.enter="wait-500" />
    }

    <!-- input -->
    @for (input of [word().audio]; track input) {
      <div class="absolute flex flex-col place-items-center gap-4" animate.leave="anim-fade-out">
        <rid-audio-button
          #audioButton
          [src]="word().audio"
          size="SMALL"
          animate.enter="wait-500 anim-pop-in"
          (animationend)="$event.animationName === 'pop-in' ? audioButton.play() : undefined"
        />

        @if (_state.type === 'REVEAL') {
          <rid-segmented-word-card
            #segmentedWordCard
            [segments]="split(word().word)"
            animate.enter="anim-pop-in"
            animate.leave="anim-pop-out"
            (mouseenter)="segmentedWordCard.decompress()"
            (mouseleave)="segmentedWordCard.compress()"
          />
        } @else {
          <rid-text-input class="min-w-2xl" animate.enter="wait-750 anim-pop-in" [appearance]="appearance()">
            <div class="flex justify-center">
              <rid-vertical-spacer><rid-compressable-klank-card content="x" /></rid-vertical-spacer>

              @for (char of text(); track $index) {
                <rid-compressable-klank-card #cards [content]="char" animate.enter="anim-pop-in" animate.leave="anim-pop-out" />
              }
              @if (_state.type === 'WRITING') {
                <rid-cursor />
              }
            </div>
          </rid-text-input>
        }
      </div>
    }

    @if (_state.type === 'WRITING' && text().length > 0) {
      <rid-bottom-button content="Klaar!" keybind="Enter" (clicked)="check()" />
    }

    @if (_state.type === 'REVEAL') {
      <rid-bottom-button content="Volgende" keybind="Enter" (clicked)="next()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
